import {observable, action, flow, makeObservable} from "mobx";

import { EAIClient } from "Services/EAIClient";
import { appStore } from "../";
import { Attachment } from "Stores/attachmentStore";

export interface Comment {
    id: string
    school_id: string
    formatted_comment: string
    comment: string
    updated: string
    created: string
    created_by: string
    task_id: number | null
    observation_id: number | null
    comment_id_display: number
    dashboard_image_url?: string
    permissions: {
        can_edit_comment: boolean
        can_delete_comment: boolean
    }
    attachments: Attachment[]
}

class CommentStore {

    @observable isProcessing: boolean;
    @observable comments?: Comment[];

    client = new EAIClient();

    constructor() {
        makeObservable(this);
    }

    @flow
    * addCommentToTicket(ticketId: string, comment: Partial<Comment>, skipSnapshotParam = false): any{
        this.isProcessing = true;
        try {
            yield this.client.addCommentToTicket(ticketId, comment, skipSnapshotParam);
            yield this.fetchCommentsForTicket(ticketId);
            this.isProcessing = false;
        } catch(e) {
            appStore.addError(e);
            this.isProcessing = false;
        }
    }

    @flow
    * updateComment(id: string, formatted_comment: string, comment: string, ticketId: string): any{
        this.isProcessing = true;
        try {
            yield this.client.updateComment({ id, comment, formatted_comment });
            yield this.fetchCommentsForTicket(ticketId);
            this.isProcessing = false;
        } catch(e) {
            appStore.addError(e);
            this.isProcessing = false;
        }
    }

    @flow
    * deleteComment(id: string): any{
        this.isProcessing = true;
        try {
            yield this.client.deleteComment(id);
        } catch(e) {
            appStore.addError(e);
        } finally {
            this.isProcessing = false;
        }
    }

    @flow
    * fetchCommentsForTicket(id: string): any{
        try {
            const resp = yield this.client.fetchCommentsForTicket(id);
            this.comments = resp.data.data;
        } catch(e) {
            appStore.addError(e);
        }
    }

    @action
    resetCommentList(){
        this.comments = undefined;
    }
}

export { CommentStore };
